import React from 'react';
import ReactDOM from 'react-dom';
import "bootstrap/dist/css/bootstrap.css"
import moment from 'moment';
import 'moment/locale/es';
import './index.css';
import './theme.css';
import Routes from './components/Routes'

// Fechas en español en todo el sistema
moment.locale('es');


ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

